import { render, staticRenderFns } from "./InCellVisitDetails.vue?vue&type=template&id=399f2440&scoped=true&"
import script from "./InCellVisitDetails.vue?vue&type=script&lang=js&"
export * from "./InCellVisitDetails.vue?vue&type=script&lang=js&"
import style0 from "./InCellVisitDetails.vue?vue&type=style&index=0&id=399f2440&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399f2440",
  null
  
)

export default component.exports